// Fancybox Start //

document.addEventListener('DOMContentLoaded', () => {

 if (typeof Fancybox === 'undefined') return;

 // =========================
 // Gallery Grouping
 // =========================
 const wrappers = document.querySelectorAll('.fancybox-wrapper');
 wrappers.forEach((wrapper, index) => {

  const galleryId = `gallery-${index}`; // wrapper単位でgalleryID生成
  const links = wrapper.querySelectorAll('.use-fancybox a'); // wrapper内のリンク取得

  links.forEach((link) => {
   const img = link.querySelector('img');
   if (!img) return;
   const thumbSrc = img.getAttribute('src'); // サムネイルURL取得
   const fullSizeUrl = thumbSrc.replace('_thumb', ''); // フルサイズURL生成
   link.setAttribute('href', fullSizeUrl);
   link.setAttribute('data-fancybox', galleryId); // Fancybox用設定
  });
 });

 // =========================
 // Fancybox Init
 // =========================
 Fancybox.bind('[data-fancybox^="gallery-"]', {
  mainStyle: {
   "--fancybox-color": "var(--wp--preset--color--neutral-100)",
   "--fancybox-backdrop-bg": "var(--wp--preset--color--overlay-100)",
   "--f-button-bg": "var(--wp--preset--color--overlay-100)",
   "--f-button-hover-color": "var(--wp--preset--color--neutral-100)",
   "--f-button-hover-bg": "var(--wp--preset--color--overlay-100)",
   "--f-arrow-pos": "0px",
   "--f-arrow-border-radius": "0px",
   "--f-caption-color": "var(--wp--preset--color--neutral-100)",
  },
  infinite: true, // 無限ループ
  Hash: false, // URL書き換え無効
  Carousel: {
   transition: "fade", // 画像切り替えエフェクト
   formatCaption: (_carouselRef, slide) => {
    return slide.triggerEl?.nextElementSibling || ""; // キャプション表示
   },
   Toolbar: {
    display: {
     right: ["close"], //ツールバー表示(右側)
    },
   },
   Zoomable: {
    Panzoom: {
     clickAction: false, //画像クリックで拡大縮小無効
     protected: true, //右クリックプロテクト
    },
   },
  },
 });
});

// Fancybox End //